import * as React from "react";
import { ActionButton } from "../../MemberShipProfile/common/ActionButton";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Divider, Form, Input, Select, Switch, Tooltip } from "antd";
import axios from "axios";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";
import { QuestionCircleOutlined, ShopOutlined } from "@ant-design/icons";
import BreadCrumb from "../../Layouts/Breadcrumb";

export const BusinessAddressForm: React.FC = () => {
  const [formData, setFormData] = React.useState({
    businessLocation: "",
    address: "",
    country: "",
    city: "",
    state: "",
    postalCode: "",
    landmark: "",
    contactName: "",
    contactNumber: "",
    email: "",
  });
  const { type, shopInfo, merchantInfo, token } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const shopId = merchantInfo?.shopId || 0;
  const shopName = merchantInfo?.shopName || "";
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [businessCountryId, setBusinessCountryId] = useState<any>(
    "65bccb6ab0a4b0fd8029ed12"
  );
  const [swhCountryId, setSwhCountryId] = useState<any>();
  const [pwCountryId, setPwCountryId] = useState<any>();
  const [spCountryId, setSpCountryId] = useState<any>();
  const [srCountryId, setSrCountryId] = useState<any>();
  const [prCountryId, setPrCountryId] = useState<any>();
  const [ppCountryId, setPpCountryId] = useState<any>();
  const [error, setError] = useState("");
  const [businessStateId, setBusinessStateId] = useState<any>();
  const [prStateId, setPrStateId] = useState<any>("");
  const [srStateId, setSrStateId] = useState<any>("");
  const [ppStateId, setPpStateId] = useState<any>("");
  const [spStateId, setSpStateId] = useState<any>("");
  const [swhStateId, setSwhStateId] = useState<any>("");
  const [pwStateId, setPwStateId] = useState<any>("");

  const [businessCityId, setBusinessCityId] = useState<any>();
  const [swhCityId, setSwhCityId] = useState<any>();
  const [pwCityId, setPwCityId] = useState<any>();
  const [spCityId, setSpCityId] = useState<any>();
  const [ppCityId, setPpCityId] = useState<any>();
  const [srCityId, setSrCityId] = useState<any>();
  const [prCityId, setPrCityId] = useState<any>();

  const [businessSubUrbId, setBusinessSubUrbId] = useState<any>();
  const [prSubUrbId, setPrSubUrbId] = useState<any>("");
  const [srSubUrbId, setSrSubUrbId] = useState<any>("");
  const [ppSubUrbId, setPpSubUrbId] = useState<any>("");
  const [spSubUrbId, setSpSubUrbId] = useState<any>("");
  const [swhSubUrbId, setSwhSubUrbId] = useState<any>("");
  const [pwSubUrbId, setPwSubUrbId] = useState<any>("");

  const [businessAreaId, setBusinessAreaId] = useState<any>();
  const [prAreaId, setPrAreaId] = useState<any>("");
  const [srAreaId, setSrAreaId] = useState<any>("");
  const [ppAreaId, setPpAreaId] = useState<any>("");
  const [spAreaId, setSpAreaId] = useState<any>("");
  const [swhAreaId, setSwhAreaId] = useState<any>("");
  const [pwAreaId, setPwAreaId] = useState<any>("");

  const [businessAddress, setBusinessAddress] = useState<any>(true);
  const [sellerWarehouseAddress, setSellerWarehouseAddress] =
    useState<any>(true);
  const [platformWarehouseAddress, setPlatformWarehouseAddress] =
    useState<any>(true);
  const [sellerPickupAddress, setSellerPickupAddress] = useState<any>(true);
  const [platformPickupAddress, setPlatformPickupAddress] = useState<any>(true);
  const [sellerReturnAddess, setSellerReturnAddess] = useState<any>(true);
  const [platformReturnAddress, setPlatformReturnAddress] = useState<any>(true);
  const [isChecked, setIsChecked] = useState(false);

  const [countryOptions, setCountryOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [swhCountryOptions, setSwhCountryOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [cityOptions, setCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [prCityOptions, setPrCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [srCityOptions, setSrCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [ppCityOptions, setPpCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [spCityOptions, setSpCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [swhCityOptions, setSwhCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [pwCityOptions, setPwCityOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [subUrbOptions, setSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [prSubUrbOptions, setPrSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [srSubUrbOptions, setSrSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [ppSubUrbOptions, setPpSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [spSubUrbOptions, setSpSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [swhSubUrbOptions, setSwhSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [pwSubUrbOptions, setPwSubUrbOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [areaOptions, setAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [prAreaOptions, setPrAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [srAreaOptions, setSrAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [ppAreaOptions, setPpAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [spAreaOptions, setSpAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [swhAreaOptions, setSwhAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [pwAreaOptions, setPwAreaOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [stateOptions, setStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [prStateOptions, setPrStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [srStateOptions, setSrStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [ppStateOptions, setPpStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [spStateOptions, setSpStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [swhStateOptions, setSwhStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [pwStateOptions, setPwStateOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [singleBusinessContactInfo, setSingleBusinessContactInfo] =
    useState<any>({
      loading: false,
      data: null,
    });
  const getCountryOptions = React.useCallback(async (key?: string) => {
    setCountryOptions({ loading: true, list: [] });

    const res = await axios.get(
      `${process.env.REACT_APP_RIDER_API}/admin/country-state/countries?isOperationEnabled=true&page=0&limit=20` +
        (key ? `&key=${key}` : ``),
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setCountryOptions({
      loading: false,
      list: res?.data?.countries?.map((country: any) => {
        return {
          value: country?.id,
          label: country?.name,
        };
      }),
    });
    setSwhCountryOptions({
      loading: false,
      list: res?.data?.countries?.map((country: any) => {
        return {
          value: country?.id,
          label: country?.name,
        };
      }),
    });
  }, []);

  const getStateOptions = useCallback(
    async (key?: string) => {
      setStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${businessCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [businessCountryId]
  );
  const getPrStateOptions = useCallback(
    async (key?: string) => {
      setPrStateOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${prCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPrStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [prCountryId]
  );
  const getSpStateOptions = useCallback(
    async (key?: string) => {
      setSpStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${spCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSpStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [spCountryId]
  );
  const getSwhStateOptions = useCallback(
    async (key?: string) => {
      setSwhStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${swhCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSwhStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [swhCountryId]
  );
  const getPwStateOptions = useCallback(
    async (key?: string) => {
      setPwStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${pwCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPwStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [pwCountryId]
  );
  const getPpStateOptions = useCallback(
    async (key?: string) => {
      setPpStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${ppCountryId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPpStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [ppCountryId]
  );
  const getSrStateOptions = useCallback(
    async (stateName?: string) => {
      setSrStateOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/states?countryId=${srCountryId}&page=0&limit=20` +
          (stateName ? `&stateName=${stateName}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSrStateOptions({
        loading: false,
        list: res?.data?.states?.map((state: any) => {
          return {
            value: state?.id,
            label: state?.name,
          };
        }),
      });
    },
    [srCountryId]
  );

  const getCityOptions = useCallback(
    async (key?: string) => {
      setCityOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${businessStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [businessStateId]
  );
  const getPrCityOptions = useCallback(
    async (key?: string) => {
      setPrCityOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${prStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPrCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [prStateId]
  );
  const getSwhCityOptions = useCallback(
    async (key?: string) => {
      setSwhCityOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${swhStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSwhCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [swhStateId]
  );
  const getPwCityOptions = useCallback(
    async (key?: string) => {
      setPwCityOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${pwStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPwCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [pwStateId]
  );
  const getSpCityOptions = useCallback(
    async (key?: string) => {
      setSpCityOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${spStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSpCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [spStateId]
  );
  const getPpCityOptions = useCallback(
    async (key?: string) => {
      setPpCityOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${ppStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPpCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [ppStateId]
  );
  const getSrCityOptions = useCallback(
    async (key?: string) => {
      setSrCityOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/admin/country-state/cities?stateId=${srStateId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSrCityOptions({
        loading: false,
        list: res?.data?.cities?.map((city: any) => {
          return {
            value: city?.id,
            label: city?.name,
          };
        }),
      });
    },
    [srStateId]
  );

  const getAreaOptions = useCallback(
    async (key?: string) => {
      setAreaOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${businessCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [businessCityId]
  );
  const getPrAreaOptions = useCallback(
    async (key?: string) => {
      setPrAreaOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${prCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPrAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [prCityId]
  );
  const getSwhAreaOptions = useCallback(
    async (key?: string) => {
      setSwhAreaOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${swhCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSwhAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [swhCityId]
  );
  const getPwAreaOptions = useCallback(
    async (key?: string) => {
      setPwAreaOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${pwCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPwAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [pwCityId]
  );
  const getSpAreaOptions = useCallback(
    async (key?: string) => {
      setSpAreaOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${spCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSpAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [spCityId]
  );
  const getPpAreaOptions = useCallback(
    async (key?: string) => {
      setPpAreaOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${ppCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPpAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [ppCityId]
  );
  const getSrAreaOptions = useCallback(
    async (key?: string) => {
      setSrAreaOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/area/all?cityId=${srCityId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSrAreaOptions({
        loading: false,
        list: res.data?.areas?.map((area: any) => ({
          label: area.name,
          value: area.id,
        })),
      });
    },
    [srCityId]
  );

  const getSubUrbOptions = useCallback(
    async (key?: string) => {
      setSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${businessAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [businessAreaId]
  );
  const getPrSubUrbOptions = useCallback(
    async (key?: string) => {
      setPrSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${prAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPrSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [prAreaId]
  );
  const getSwhSubUrbOptions = useCallback(
    async (key?: string) => {
      setSwhSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${swhAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSwhSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [swhAreaId]
  );
  const getPwSubUrbOptions = useCallback(
    async (key?: string) => {
      setPwSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${pwAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPwSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [pwAreaId]
  );
  const getSpSubUrbOptions = useCallback(
    async (key?: string) => {
      setSpSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${spAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSpSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [spAreaId]
  );
  const getPpSubUrbOptions = useCallback(
    async (key?: string) => {
      setPpSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${ppAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPpSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [ppAreaId]
  );
  const getSrSubUrbOptions = useCallback(
    async (key?: string) => {
      setSrSubUrbOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_RIDER_API}/suburb/all?areaId=${srAreaId}&page=0&limit=20` +
          (key ? `&key=${key}` : ``),

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSrSubUrbOptions({
        loading: false,
        list: res.data?.suburbs?.map((suburb: any) => ({
          label: suburb.name,
          value: suburb.id,
        })),
      });
    },
    [srAreaId]
  );
  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      isSamePickUpAddress: sellerPickupAddress || true,
      isSamePlatformPickUpAddress: platformPickupAddress || true,
      isSamePlatformReturnAddress: platformReturnAddress || true,
      isSamePlatformWarehouseAddress: platformWarehouseAddress || true,
      isSameReturnAddress: sellerReturnAddess || true,
      isSameWarehouseAddress: sellerWarehouseAddress || true,
      merchantBusinessAndContactInfo: {
        address: data.businessAddress,
        cityId: businessCityId,
        areaId: businessAreaId,
        suburbId: businessSubUrbId,
        contactPersonEmail: data.businessContractEmail,
        contactPersonName: data.businessContactPerson,
        contactPersonNumber: data.businessContractNumber,
        countryId: businessCountryId,
        nearestLandMark: data.businessNearestLandMark,
        postalCode: data.postalCode,
        stateId: businessStateId,
      },
      pickupAddressInfos: {
        address: data.spAddress,
        city: spCityId,
        contactPersonEmail: data.spContactEmail,
        contactPersonName: data.spContactPerson,
        contactPersonNumber: data.spContractNumber,
        country: spCountryId,
        nearestLandMark: data.spNearestLandMark,
        postalCode: data.spPostalCode,
        state: spStateId,
        spAreaId: spAreaId,
        spSubUrbId: spSubUrbId,
      },
      platformPickUpAddress: {
        address: data.ppAddress,
        city: ppCityId,
        contactPersonEmail: data.ppContactEmail,
        contactPersonName: data.ppContactPerson,
        contactPersonNumber: data.ppContactNumber,
        country: ppCountryId,
        nearestLandMark: data.ppNearestLandMark,
        postalCode: data.ppPostalCode,
        state: ppStateId,
        ppAreaId: ppAreaId,
        ppSubUrbId: ppSubUrbId,
      },
      platformReturnAddress: {
        address: data.prAddress,
        city: prCityId,
        contactPersonEmail: data.prContactEmail,
        contactPersonName: data.prContactPerson,
        contactPersonNumber: data.prContractNumber,
        country: prCountryId,
        nearestLandMark: data.prNearestLandMark,
        postalCode: data.prPostalCode,
        state: prStateId,
        prAreaId: prAreaId,
        prSubUrbId: prSubUrbId,
      },
      platformWarehouseAddress: {
        address: data.pwAddress,
        city: pwCityId,
        contactPersonEmail: data.pwContactEmail,
        contactPersonName: data.pwContactPerson,
        contactPersonNumber: data.pwContractNumber,
        country: pwCountryId,
        nearestLandMark: data.pwNearestLandMark,
        postalCode: data.pwPostalCode,
        state: pwStateId,
        pwAreaId: pwAreaId,
        pwSubUrbId: pwSubUrbId,
      },
      returnAddressInfos: {
        address: data.srAddress,
        city: srCityId,
        contactPersonEmail: data.srContactEmail,
        contactPersonName: data.srContactPerson,
        contactPersonNumber: data.srContractNumber,
        country: srCountryId,
        nearestLandMark: data.srNearestLandMark,
        postalCode: data.srPostalCode,
        state: srStateId,
        srAreaId: srAreaId,
        srSubUrbId: srSubUrbId,
      },
      shopId: merchantInfo?.shopId || 0,
      warehouseAddressInfos: {
        address: data.swhAddress,
        city: swhCityId,
        contactPersonEmail: data.swhContactEmail,
        contactPersonName: data.swhContactPerson,
        contactPersonNumber: data.swhContractNumber,
        country: swhCountryId,
        nearestLandMark: data.swhNearestLandMark,
        postalCode: data.swhPostalCode,
        state: swhStateId,
        swhAreaId: swhAreaId,
        swhSubUrbId: swhSubUrbId,
      },
    };
    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/shop/business-contact-info`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...readyData }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          responseNotification(" Update Successfully", "success");
          form.resetFields();
          navigate("/merchant-profile");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  const fetchRef = useRef(0);
  const handleSearch = useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "country") getCountryOptions(value);
        if (field === "state") getStateOptions(value);
        if (field === "prState") getPrStateOptions(value);
        if (field === "srState") getSrStateOptions(value);
        if (field === "ppState") getPpStateOptions(value);
        if (field === "spState") getSpStateOptions(value);
        if (field === "pwState") getPwStateOptions(value);
        if (field === "swhState") getSwhStateOptions(value);
        if (field === "city") getCityOptions(value);
        if (field === "prCity") getPrCityOptions(value);
        if (field === "srCity") getSrCityOptions(value);
        if (field === "ppCity") getPpCityOptions(value);
        if (field === "spCity") getSpCityOptions(value);
        if (field === "swhCity") getSwhCityOptions(value);
        if (field === "pwCity") getPwCityOptions(value);
        if (field === "area") getAreaOptions(value);
        if (field === "prArea") getPrAreaOptions(value);
        if (field === "srArea") getSrAreaOptions(value);
        if (field === "ppArea") getPpAreaOptions(value);
        if (field === "spArea") getSpAreaOptions(value);
        if (field === "swhArea") getSwhAreaOptions(value);
        if (field === "pwArea") getPwAreaOptions(value);
        if (field === "subUrb") getSubUrbOptions(value);
        if (field === "prSubUrb") getPrSubUrbOptions(value);
        if (field === "srSubUrb") getSrSubUrbOptions(value);
        if (field === "ppSubUrb") getPpSubUrbOptions(value);
        if (field === "spSubUrb") getSpSubUrbOptions(value);
        if (field === "swhSubUrb") getSwhSubUrbOptions(value);
        if (field === "pwSubUrb") getPwSubUrbOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getCountryOptions,
    getCityOptions,
    getSpCityOptions,
    getSwhCityOptions,
    getPwCityOptions,
    getStateOptions,
    getSwhStateOptions,
    getPwStateOptions,
    getSpStateOptions,
    getPpCityOptions,
    getPpStateOptions,
    getSrCityOptions,
    getSrStateOptions,
    getPrCityOptions,
    getPrStateOptions,
    getAreaOptions,
    getPrAreaOptions,
    getSrAreaOptions,
    getPpAreaOptions,
    getSpAreaOptions,
    getSwhAreaOptions,
    getPwAreaOptions,
    getSubUrbOptions,
    getPrSubUrbOptions,
    getSrSubUrbOptions,
    getPpSubUrbOptions,
    getSpSubUrbOptions,
    getSwhSubUrbOptions,
    getPwSubUrbOptions,
    type,
  ]);
  useEffect(() => {
    getCountryOptions();
    getStateOptions();
    getSwhStateOptions();
    getCityOptions();
    getSwhCityOptions();
    getPwCityOptions();
    getPwStateOptions();
    getSpCityOptions();
    getPpCityOptions();
    getSrCityOptions();
    getAreaOptions();
    getSwhAreaOptions();
    getPwAreaOptions();
    getSpAreaOptions();
    getPpAreaOptions();
    getSrAreaOptions();
    getPrAreaOptions();
    getSubUrbOptions();
    getSwhSubUrbOptions();
    getPwSubUrbOptions();
    getPrSubUrbOptions();
    getSpSubUrbOptions();
    getPpSubUrbOptions();
    getSrSubUrbOptions();
    getSpStateOptions();
    getPpStateOptions();
    getSrStateOptions();
    getPrCityOptions();
    getPrStateOptions();
  }, [
    getCountryOptions,
    getStateOptions,
    getCityOptions,
    getSpCityOptions,
    getSwhCityOptions,
    getPwCityOptions,
    getPpCityOptions,
    getPrCityOptions,
    getSrCityOptions,
    getAreaOptions,
    getSpAreaOptions,
    getSwhAreaOptions,
    getPwAreaOptions,
    getPpAreaOptions,
    getPrAreaOptions,
    getSrAreaOptions,
    getSubUrbOptions,
    getSpSubUrbOptions,
    getSwhSubUrbOptions,
    getPwSubUrbOptions,
    getPpSubUrbOptions,
    getPrSubUrbOptions,
    getSrSubUrbOptions,
    getPwStateOptions,
    getSpStateOptions,
    getPpStateOptions,
    getSrStateOptions,
    getPrStateOptions,
  ]);

  const fetchBusinessContactDetails = useCallback((shopId: any) => {
    if (shopId) {
      try {
        setSingleBusinessContactInfo({ loading: true, data: null });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/merchant-shop/my-shop-details?shopId=${shopId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleBusinessContactInfo({
                loading: false,
                data: data?.data?.shop,
              });
              setSellerWarehouseAddress("");
              setPlatformWarehouseAddress("");
              setSellerPickupAddress("");
              setPlatformPickupAddress("");
              setSellerReturnAddess("");
              setPlatformReturnAddress("");
            } else {
              setSingleBusinessContactInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleBusinessContactInfo({ loading: false, data: null });
          });
      } catch (error) {
        setSingleBusinessContactInfo({ loading: false, data: null });
      }
    }
  }, []);

  useEffect(() => {
    fetchBusinessContactDetails(shopId);
  }, [fetchBusinessContactDetails, shopId]);
  useEffect(() => {
    if (businessCountryId) {
      form.setFieldsValue({ businessCountry: businessCountryId });
      form.validateFields(["businessCountry"]).catch(() => {});
    }
  }, [businessCountryId, form]);

  useEffect(() => {
    if (singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo) {
      form.resetFields();
      const info =
        singleBusinessContactInfo.data?.merchantBusinessAndContactInfo;

      // 1️⃣ Form values set
      form.setFieldsValue({
        businessCountry: info.countryId,
        businessState: info.stateId,
        businessCity: info.cityId,
        businessArea: info.areaId,
        businessSubUrb: info.suburbId,
      });

      setBusinessCountryId(info.countryId);
      setBusinessStateId(info.stateId);
      setBusinessCityId(info.cityId);
      setBusinessAreaId(info.areaId);
      setBusinessSubUrbId(info.suburbId);
    }
  }, [form, singleBusinessContactInfo?.data]);

  const resetData = () => {
    form?.resetFields();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <main className="mx-auto w-full max-w-6xl px-4 md:px-8 py-6 md:py-10">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          onFinish={onSubmit}
          initialValues={{
            ...singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo,
            businessAddress:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.address || "",
            postalCode:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.postalCode || "",
            businessNearestLandMark:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.nearestLandMark || "",
            businessContactPerson:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.contactPersonName || "",
            businessContractNumber:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.contactPersonNumber || "",
            businessContractEmail:
              singleBusinessContactInfo?.data?.merchantBusinessAndContactInfo
                ?.contactPersonEmail || "",
  
            // sellerWarehouseAddress
            swhAddress:
              singleBusinessContactInfo?.data?.warehouseAddressInfos?.address ||
              "",
            swhPostalCode:
              singleBusinessContactInfo?.data?.warehouseAddressInfos?.postalCode ||
              "",
            swhNearestLandMark:
              singleBusinessContactInfo?.data?.warehouseAddressInfos
                ?.nearestLandMark || "",
            swhContactPerson:
              singleBusinessContactInfo?.data?.warehouseAddressInfos
                ?.contactPersonName || "",
            swhContractNumber:
              singleBusinessContactInfo?.data?.warehouseAddressInfos
                ?.contactPersonNumber || "",
            swhContactEmail:
              singleBusinessContactInfo?.data?.warehouseAddressInfos
                ?.contactPersonEmail || "",
  
            // platformWarehouseAddress
            pwAddress:
              singleBusinessContactInfo?.data?.platformWarehouseAddress?.address ||
              "",
            pwPostalCode:
              singleBusinessContactInfo?.data?.platformWarehouseAddress
                ?.postalCode || "",
            pwNearestLandMark:
              singleBusinessContactInfo?.data?.platformWarehouseAddress
                ?.nearestLandMark || "",
            pwContactPerson:
              singleBusinessContactInfo?.data?.platformWarehouseAddress
                ?.contactPersonName || "",
            pwContractNumber:
              singleBusinessContactInfo?.data?.platformWarehouseAddress
                ?.contactPersonNumber || "",
            pwContactEmail:
              singleBusinessContactInfo?.data?.platformWarehouseAddress
                ?.contactPersonEmail || "",
  
            // sellerPickupAddress
            spAddress:
              singleBusinessContactInfo?.data?.pickupAddressInfos?.address || "",
            spPostalCode:
              singleBusinessContactInfo?.data?.pickupAddressInfos?.postalCode ||
              "",
            spNearestLandMark:
              singleBusinessContactInfo?.data?.pickupAddressInfos
                ?.nearestLandMark || "",
            spContactPerson:
              singleBusinessContactInfo?.data?.pickupAddressInfos
                ?.contactPersonName || "",
            spContractNumber:
              singleBusinessContactInfo?.data?.pickupAddressInfos
                ?.contactPersonNumber || "",
            spContactEmail:
              singleBusinessContactInfo?.data?.pickupAddressInfos
                ?.contactPersonEmail || "",
  
            // platformPickupAddress
            ppAddress:
              singleBusinessContactInfo?.data?.platformPickUpAddress?.address || "",
            ppPostalCode:
              singleBusinessContactInfo?.data?.platformPickUpAddress?.postalCode ||
              "",
            ppNearestLandMark:
              singleBusinessContactInfo?.data?.platformPickUpAddress
                ?.nearestLandMark || "",
            ppContactPerson:
              singleBusinessContactInfo?.data?.platformPickUpAddress
                ?.contactPersonName || "",
            ppContactNumber:
              singleBusinessContactInfo?.data?.platformPickUpAddress
                ?.contactPersonNumber || "",
            ppContactEmail:
              singleBusinessContactInfo?.data?.platformPickUpAddress
                ?.contactPersonEmail || "",
  
            // sellerReturnAddress
            srAddress:
              singleBusinessContactInfo?.data?.returnAddressInfos?.address || "",
            srPostalCode:
              singleBusinessContactInfo?.data?.returnAddressInfos?.postalCode || "",
            srNearestLandMark:
              singleBusinessContactInfo?.data?.returnAddressInfos
                ?.nearestLandMark || "",
            srContactPerson:
              singleBusinessContactInfo?.data?.returnAddressInfos
                ?.contactPersonName || "",
            srContractNumber:
              singleBusinessContactInfo?.data?.returnAddressInfos
                ?.contactPersonNumber || "",
            srContactEmail:
              singleBusinessContactInfo?.data?.returnAddressInfos
                ?.contactPersonEmail || "",
  
            // platformReturnAddress
            prAddress:
              singleBusinessContactInfo?.data?.platformReturnAddress?.address || "",
            prPostalCode:
              singleBusinessContactInfo?.data?.platformReturnAddress?.postalCode ||
              "",
            prNearestLandMark:
              singleBusinessContactInfo?.data?.platformReturnAddress
                ?.nearestLandMark || "",
            prContactPerson:
              singleBusinessContactInfo?.data?.platformReturnAddress
                ?.contactPersonName || "",
            prContractNumber:
              singleBusinessContactInfo?.data?.platformReturnAddress
                ?.contactPersonNumber || "",
            prContactEmail:
              singleBusinessContactInfo?.data?.platformReturnAddress
                ?.contactPersonEmail || "",
          }}
          form={form}
          layout="vertical"
          autoComplete="off"
          className="w-full"
        >
          {/* ===== Header ===== */}
          <div className="mb-6">
            <div className="text-2xl md:text-3xl font-bold text-zinc-900">
              Business &amp; Contact address
            </div>
            <div className="mt-1 text-sm text-zinc-500">
              Provide your business contact details and address information.
            </div>
          </div>
  
          {/* ===== Main Card (like screenshot) ===== */}
          <div className="bg-white rounded-2xl shadow-sm border border-zinc-100 p-5 md:p-8">
            {/* Shop name row */}
            <div className="flex items-center justify-between gap-4 mb-6">
              <div className="text-xl md:text-2xl font-semibold text-zinc-900 flex items-center gap-2">
                <ShopOutlined />
                <span>{shopName}</span>
              </div>
  
              {/* Business Address switch (NOT a form field) */}
              <div className="flex items-center gap-3">
                <div className="text-sm font-semibold text-zinc-800">
                  Business Address
                </div>
                <Switch
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  checked={!!businessAddress}
                  onChange={setBusinessAddress}
                />
              </div>
            </div>
  
            {/* Form grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-5">
              {/* LEFT COLUMN (like screenshot) */}
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">State/Province</span>}
                rules={[{ required: true, message: "State is required!" }]}
                name="businessState"
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select State/Province"
                  optionFilterProp="children"
                  onChange={(val) => setBusinessStateId(val)}
                  onSearch={(val) => handleSearch?.(val, "state")}
                  filterOption={() => true}
                  options={stateOptions?.list}
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Country/Region</span>}
                name="businessCountry"
                rules={[{ required: true, message: "Region is required!" }]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Country"
                  optionFilterProp="children"
                  value={businessCountryId}
                  onChange={(val) => {
                    setBusinessCountryId(val);
                    form.setFieldsValue({ businessCountry: val });
                    form.validateFields(["businessCountry"]).catch(() => {});
                  }}
                  onClear={() => {
                    setBusinessCountryId(undefined);
                    form.setFieldsValue({ businessCountry: undefined });
                  }}
                  onSearch={(e) => handleSearch(e, "country")}
                  filterOption={() => true}
                  options={countryOptions?.list}
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Area</span>}
                name="businessArea"
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Area"
                  optionFilterProp="children"
                  onChange={(val) => setBusinessAreaId(val)}
                  onSearch={(val) => handleSearch?.(val, "area")}
                  filterOption={() => true}
                  options={areaOptions?.list}
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">City</span>}
                name="businessCity"
                rules={[{ required: true, message: "City is required!" }]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select City"
                  optionFilterProp="children"
                  onChange={(val) => setBusinessCityId(val)}
                  onSearch={(val) => handleSearch?.(val, "city")}
                  filterOption={() => true}
                  options={cityOptions?.list}
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Postal/Gip Code</span>}
                name="postalCode"
              >
                <Input
                  id="postalCode"
                  type="number"
                  placeholder="Enter Postal/Gip Code"
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Sub-Urb</span>}
                name="businessSubUrb"
              >
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Sub-Urb"
                  optionFilterProp="children"
                  onChange={(val) => setBusinessSubUrbId(val)}
                  onSearch={(val) => handleSearch?.(val, "subUrb")}
                  filterOption={() => true}
                  options={subUrbOptions?.list}
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Contact Person Name</span>}
                name="businessContactPerson"
                rules={[
                  { pattern: /^[A-Za-z\s]+$/, message: "Only alphabets are allowed!" },
                ]}
              >
                <Input
                  id="businessContactPerson"
                  type="text"
                  placeholder="Enter Contact Person Name"
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Nearest Landmark</span>}
                name="businessNearestLandMark"
              >
                <Input
                  id="businessNearestLandMark"
                  type="text"
                  placeholder="Enter Nearest Landmark"
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Email</span>}
                name="businessContractEmail"
              >
                <Input
                  id="businessContractEmail"
                  type="email"
                  placeholder="Enter Email"
                />
              </Form.Item>
  
              <Form.Item
                hasFeedback
                label={<span className="font-semibold">Contact Person Number</span>}
                name="businessContractNumber"
              >
                <Input
                  id="businessContractNumber"
                  type="number"
                  placeholder="Enter Contact Person Number"
                />
              </Form.Item>
  
              {/* Full Address spans 2 columns like screenshot */}
              <div className="md:col-span-2">
                <Form.Item
                  hasFeedback
                  label={<span className="font-semibold">Address</span>}
                  rules={[{ required: true, message: "Full Address is Required!" }]}
                  name="businessAddress"
                >
                  <Input
                    id="businessAddress"
                    type="text"
                    placeholder="Enter Full Address"
                  />
                </Form.Item>
              </div>
            </div>
  
            {/* Buttons */}
            <div className="mt-6 flex flex-col sm:flex-row gap-3 sm:justify-end">
              <Button
                disabled={loading || !!error}
                loading={loading}
                type="primary"
                htmlType="submit"
                className="h-10 px-8 rounded-xl"
              >
                Submit
              </Button>
  
              <Button
                htmlType="button"
                onClick={() => form?.resetFields()}
                className="h-10 px-8 rounded-xl"
              >
                Reset
              </Button>
            </div>
          </div>
  
          {/* ===== Toggle Section Card (same as screenshot style) ===== */}
          <div className="mt-6 bg-white rounded-2xl shadow-sm border border-zinc-100 p-5 md:p-8">
            <div className="space-y-4">
              {[
                {
                  title: "Seller Warehouse Address",
                  desc: "Same as business Address",
                  onChange: setSellerWarehouseAddress,
                },
                {
                  title: "Platform Warehouse Address",
                  desc: "Same as business Address",
                  onChange: setPlatformWarehouseAddress,
                },
                {
                  title: "Seller Pickup Address",
                  desc: "Same as business Address",
                  onChange: setSellerPickupAddress,
                },
                {
                  title: "Platform Pickup Address",
                  desc: "Same as business Address",
                  onChange: setPlatformPickupAddress,
                },
                {
                  title: "Seller Return Address",
                  desc: "Same as business Address",
                  onChange: setSellerReturnAddess,
                },
                {
                  title: "Platform Return Address",
                  desc: "Same as business Address",
                  onChange: setPlatformReturnAddress,
                },
              ]?.map((row, idx) => (
                <div
                  key={idx}
                  className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 border border-zinc-100 rounded-xl px-4 py-3"
                >
                  <div className="flex items-start gap-3">
                    <div>
                      <div className="text-sm md:text-base font-bold text-zinc-800">
                        {row.title}
                      </div>
                      <div className="text-xs text-zinc-500">{row.desc}</div>
                    </div>
  
                    <Tooltip placement="bottom" title={row.desc}>
                      <QuestionCircleOutlined className="mt-1 text-zinc-400" />
                    </Tooltip>
                  </div>
  
                  <Switch
                    checkedChildren="Yes"
                    unCheckedChildren="No"
                    defaultChecked={true}
                    onChange={row.onChange as any}
                  />
                </div>
              ))}
            </div>
          </div>
  
          {/* ===== তোমার বাকি conditional sections (sellerWarehouseAddress === false ইত্যাদি) ===== */}
          {/* এগুলো তুমি আগের মতোই নিচে রাখতে পারো (ফাংশনালিটি unchanged). */}
          {/* চাইলে আমি এগুলোকেও একই কার্ড ডিজাইনে সাজিয়ে দিতে পারি। */}
        </Form>
      </main>
    </div>
  );
  
};

export default BusinessAddressForm;
